import { __ } from '@wordpress/i18n';
import { isAprimo, aprimoType, attachAprimoVideo } from '../../js/parts/aprimo-video.js';

jQuery(function ($) {
	/**
	 * Matat_Pandora_MiniCart handles WooCommerce mini cart rendering and actions.
	 */
	class Matat_Pandora_MiniCart {
		/**
		 * Constructor initializes DOM elements, API config, and strings.
		 */
		constructor() {
			this.$wrapper = $('.wp-block-pandora-mini-cart');
			this.$cartBtn = this.$wrapper.find('.pandora_mini_cart_control');
			this.$cartHeader = this.$wrapper.find('.pandora-cart-header');
			this.$cartBox = this.$wrapper.find('.pandora-cart-body');
			this.$cartFooter = this.$wrapper.find('.pandora-cart-body');
			this.apiBase =
				typeof mpParams !== 'undefined' ? mpParams.restUrl : '';
			this.ajaxUrl =
				typeof mpParams !== 'undefined' ? mpParams.ajaxUrl : '';
			this.nonce = typeof mpParams !== 'undefined' ? mpParams.nonce : '';
			this.minicartSaleNotification = this.$wrapper.find(
				'.mini-cart-sale-notification'
			);

			// Load all localized/customizable strings via data attributes
			this.texts = {
				addToCart: this.$wrapper.data('add-to-cart-text'),
				emptyCartMessage: this.$wrapper.data('empty-cart-message'),
				startShoppingText: this.$wrapper.data('start-shopping-text'),
				proceedToCheckoutText: this.$wrapper.data('checkout-text'),
				subtotalText: this.$wrapper.data('subtotal-text'),
				removeItemText: this.$wrapper.data('remove-text'),
				freeShippingCongrats: this.$wrapper.data(
					'free-shipping-congrats'
				),
				freeShippingMissing: this.$wrapper.data(
					'free-shipping-missing'
				),
				freeShippingExact: this.$wrapper.data('free-shipping-exact'),
				cartText: this.$wrapper.data('cart-text'),
			};

			// Get placeholder image URL from data attribute
			this.placeholderImg = this.$wrapper.data('placeholder-img') || '';

			// If required elements or config is missing, abort setup
			if (
				!this.$wrapper.length ||
				!this.apiBase ||
				!this.$cartBtn.length ||
				!this.$cartBox.length
			) {
				return;
			}

			this.swiperInstance = null;
			this.isDragging = false;
			this.eventHandlers();
		}

		/**
		 * Attach event handlers for cart actions: toggle, quantity change, remove, refresh.
		 */
		eventHandlers() {
			// Toggle mini cart visibility
			$(document).on(
				'click',
				'.pandora_mini_cart_control, .min-cart-close',
				this.toggleCart.bind(this)
			);

			// Close cart when clicking outside
			$(document).on('click', this.handleOutsideClick.bind(this));

			// Handle quantity updates
			$(document.body).on(
				'change',
				'.cart_qty',
				this.updateCartItem.bind(this)
			);
			$(document.body).on(
				'click',
				'a.cart-remove',
				this.removeCartItem.bind(this)
			);
			$(document.body).on(
				'click',
				'button.add_to_cart_button',
				this.addToCart.bind(this)
			);

			$(document.body).on('added_to_cart', (e, fragments, cart_hash, $thisbutton) => {
				// Skip for upsell items - handled separately to chain loader removal
				if ($thisbutton && $thisbutton.closest('.mini-upsell-wrappper').length) {
					return;
				}
				// Fetch cart and remove loader when complete (loader is shown in the toggle handler)
				this.fetchCart().always(() => {
					this.$wrapper.find('.pandora-cart-widget-wrapper').removeClass('show-loader');
				});
			});
			$(document.body).ready(this.fetchCart());

			// on Adding to cart, check if it's from Quick View and change text on $thisbutton to "Added to Cart"
			$(document.body).on('adding_to_cart', (e, $thisbutton, data) => {
				if ($thisbutton && $thisbutton.closest('.pandora-quick-view-details').length) {
					$thisbutton.addClass('loading');
					$thisbutton.html('<span class="loading-text">מוסיף</span>');
				}
			});

			$(document).on('added_to_cart', (e, fragments, cart_hash, $thisbutton) => {
				// Guard against undefined $thisbutton (e.g., from engraving drawer)
				if (!$thisbutton) {
					return;
				}
				if ($thisbutton && $thisbutton.closest('.pandora-quick-view-details').length) {
					$thisbutton.html('<span class="added-text">נוסף לסל ✓</span>');
				}
				else if ($thisbutton && $thisbutton.closest('.mini-upsell-wrappper').length) {
					// Remove the added item from upsell carousel immediately for visual feedback
					// Server will filter it out on next fetchCart() based on cart contents
					const $slide = $thisbutton.closest('.swiper-slide');
					if ($slide.length && this.swiperInstance) {
						$slide.remove();
						this.swiperInstance.update();
						// If no more slides, hide the upsell wrapper
						if (this.swiperInstance.slides.length === 0) {
							this.$wrapper.find('.mini-upsell-wrappper').hide();
						}
					}
					// Call fetchCart and wait for it to complete before removing loader
					this.fetchCart()
						.always(() => {
							this.$wrapper
								.find('.pandora-cart-widget-wrapper')
								.removeClass('show-loader');
						});
					// Don't close the minicart
				}
				else {
					// Show loader before opening cart to prevent empty cart flash
					this.$wrapper.find('.pandora-cart-widget-wrapper').addClass('show-loader');
					this.toggleCart();
				}
			});
			$(document.body).on(
				'click',
				'button.close-upsell-form',
				this.closeCrossSell.bind(this)
			);

			$(document).on(
				'click',
				'.qty-btn',
				this.handleCartQuantityChange.bind(this)
			);

			// Handle variation selection in upsell
			$(document).on(
				'change',
				'.mini-upsell-wrappper .size-swiper input[type="radio"]',
				this.handleVariationSelect.bind(this)
			);

			// Track drag state to prevent closing cart during swipe/drag
			$(document).on('mousedown touchstart', '.mini-upsell-wrappper', () => {
				this.isDragging = true;
			});
			$(document).on('mouseup touchend', () => {
				// Delay reset to allow click event to be processed first
				setTimeout(() => {
					this.isDragging = false;
				}, 100);
			});
		}

		handleCartQuantityChange(e) {
			e.preventDefault();
			const $button = $(e.currentTarget);
			const $container = $button.closest('.cart-quantity-controls');
			const $input = $container.find('.cart_qty').first();
			if (!$input.length) {
				return;
			}

			const isPlus = $button.hasClass('qty-plus');
			let quantity = parseInt($input.val(), 10);
			if (isNaN(quantity) || quantity < 1) {
				quantity = 1;
			}

			// When decrementing from 1, remove the item from cart instead
			if (!isPlus && quantity <= 1) {
				const key = $input.data('key');
				if (!key) return;
				const self = this;
				this.$wrapper
					.find('.pandora-cart-widget-wrapper')
					.addClass('show-loader');
				$.ajax({
					url: self.apiBase + 'wc/store/v1/cart/remove-item',
					type: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Nonce: self.nonce,
					},
					data: JSON.stringify({ key }),
					success: function () {
						// GTM: fetch the buffered removedFromCart event.
						$(document.body).trigger('pandora_removed_from_cart');
						self.fetchCart().always(function () {
							self.$wrapper
								.find('.pandora-cart-widget-wrapper')
								.removeClass('show-loader');
						});
					},
					error: function (xhr) {
						console.error('Remove failed:', xhr.responseJSON || xhr);
						self.$wrapper
							.find('.pandora-cart-widget-wrapper')
							.removeClass('show-loader');
					},
				});
				return;
			}

			// show loader immediately on user action
			this.$wrapper
				.find('.pandora-cart-widget-wrapper')
				.addClass('show-loader');
			const nextQuantity = isPlus ? quantity + 1 : quantity - 1;
			$input.val(nextQuantity).trigger('change');
			// fallback: ensure loader hides if AJAX fails completely (extended timeout)
			setTimeout(() => {
				this.$wrapper
					.find('.pandora-cart-widget-wrapper')
					.removeClass('show-loader');
			}, 15000);
		}

		/**
		 * Handle variation selection in upsell products.
		 * @param {Event} e - Change event
		 */
		handleVariationSelect(e) {
			const $input = $(e.currentTarget);
			const $item = $input.closest('.mini-upsell-item');
			const $button = $item.find('.btn-upsell-add-cart');
			const $slide = $input.closest('.swiper-slide');
			const variationId = $input.data('variation_id');

			// Mark selected variation
			$item.find('.swiper-slide.variable-item').removeClass('is-selected');
			$slide.addClass('is-selected');

			if (variationId && variationId !== 0) {
				$button.prop('disabled', false);
				$button.attr('data-variation_id', variationId);
			} else {
				$button.prop('disabled', true);
				$button.attr('data-variation_id', 0);
			}
		}

		/**
		 * Handle add to cart action.
		 * @param {Event} e - Click event
		 */
		addToCart(e) {
			e.preventDefault();
			const self = this;
			const $thisbutton = $(e.currentTarget);
			const productId = $thisbutton.data('product_id');
			const variationId = $thisbutton.data('variation_id') || 0;
			const isUpsell = $thisbutton.closest('.mini-upsell-wrappper').length > 0;

			// Build request data
			const requestData = {
				product_id: variationId > 0 ? variationId : productId,
				quantity: 1,
			};

			// For variable products, add variation data
			if (variationId > 0) {
				requestData.variation_id = variationId;
			}

			$.ajax({
				type: 'POST',
				url: woocommerce_params.wc_ajax_url
					.toString()
					.replace('%%endpoint%%', 'add_to_cart'),
				data: requestData,
				beforeSend: function (response) {
					$thisbutton.prop('disabled', true);
					$thisbutton.removeClass('added').addClass('loading');
					// Show loader for upsell add to cart
					if (isUpsell) {
						self.$wrapper
							.find('.pandora-cart-widget-wrapper')
							.addClass('show-loader');
					}
				},
				complete: function (response) {
					$thisbutton.prop('disabled', false);
					$thisbutton.addClass('added').removeClass('loading');
				},
				success: function (response) {
					if (response.error && response.product_url) {
						// Remove loader on redirect
						if (isUpsell) {
							self.$wrapper
								.find('.pandora-cart-widget-wrapper')
								.removeClass('show-loader');
						}
						window.location = response.product_url;
						return;
					}
					// Fire WooCommerce hooks
					$(document.body).trigger('added_to_cart', [
						response.fragments,
						response.cart_hash,
						$thisbutton,
					]);
				},
				error: function () {
					// Remove loader on error
					if (isUpsell) {
						self.$wrapper
							.find('.pandora-cart-widget-wrapper')
							.removeClass('show-loader');
					}
				},
			});
		}

		/**
		 * Toggle cart visibility and body class.
		 * @param {Event} e - Click event
		 */
		toggleCart(e) {
			// e.preventDefault();
			const sidebar = this.$wrapper.find('.min-cart-sidebar');
			if($('body').hasClass('is-mini-cart-open')) {
				$('body').removeClass('is-mini-cart-open');
				setTimeout(() => {
					$('body').removeClass('disable-transform');
				}, 500);
				sidebar.removeClass('toggle-show');
			} else {
				$('body').addClass('is-mini-cart-open');
				setTimeout(() => {
					$('body').addClass('disable-transform');
				}, 500);
				sidebar.addClass('toggle-show');
			}
		}

		/**
		 * Handle clicks outside the mini cart to close it.
		 * @param {Event} e - Click event
		 */
		handleOutsideClick(e) {
			// Check if mini cart is open - return if cart is not open (either class missing means cart is closed/closing)
			if (!$('body').hasClass('is-mini-cart-open') && !$('body').hasClass('disable-transform')) {
				return;
			}

			// Don't close if dragging (e.g., swiping upsell carousel)
			if (this.isDragging) {
				return;
			}

			const $target = $(e.target);

			// Don't close if clicking on the cart button or inside the mini cart
			if (!$target.closest('.pandora_mini_cart_control').length &&
				!$target.closest('.pandora-cart-widget-wrapper').length
			) {
				// Close the cart
				const sidebar = this.$wrapper.find('.min-cart-sidebar');
				$('body').removeClass('is-mini-cart-open');
				setTimeout(() => {
					$('body').removeClass('disable-transform');
				}, 500);
				sidebar.removeClass('toggle-show');
			}
		}

		/**
		 * Format price from cents to readable currency string.
		 * @param {number} amount - Amount in cents
		 * @param {string} symbol - Currency symbol
		 * @returns {string}
		 */
		formatPrice(amount, symbol) {
			return symbol + (amount / 100).toFixed(2);
		}

		/**
		 * Render cross-sell products inside the mini cart.
		 * @param {Array} products - List of product objects
		 * @returns {jQuery} - Rendered Swiper slider HTML
		 */
		renderCrossSellProducts(products) {
			const self = this;
			const $sliderWrap = $(
				`
				<div class="mini-upsell-wrappper">
					<div class="mini-upsell-header">
						<button type="button" aria-label="Close Upsell Form" class="close-upsell-form" data-acsb-clickable="true" data-acsb-navigable="true" data-acsb-now-navigable="true">
							<svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 13.692 13.688" aria-hidden="true" data-acsb-hidden="true">
								<path d="M19.753,18.133l4.89-4.89a1.146,1.146,0,0,0-1.621-1.62l-4.89,4.89-4.89-4.89a1.146,1.146,0,1,0-1.621,1.62l4.89,4.89-4.89,4.89a1.146,1.146,0,1,0,1.621,1.62l4.89-4.89,4.89,4.89a1.146,1.146,0,1,0,1.62-1.62Z" transform="translate(-11.285 -11.289)"></path>
							</svg>
						</button>
						<p class="upsell-title"> ` +
				minicartUpsell.minicart_title +
				`</p>
					</div>
					<div class="mini-upsell-wrap swiper-container" dir="rtl">
						<div class="swiper-wrapper"></div>
						<div class="swiper-pagination"></div>
					</div>
				</div>
			`
			);

			const $wrapper = $sliderWrap.find('.swiper-wrapper');

			products.forEach((product) => {
				let variationHtml = '';

				// Check if product is variable and has variations
				// Variations can be in product.variations or product.product_variations
				const variations = product.variations || product.product_variations || [];

				// Detect variable products by: type or variations array
				// Note: Don't use price_html hyphen detection as it matches discount badges like "25%-"
				const isVariable = product.type === 'variable' || variations.length > 0;

				if (isVariable && variations.length > 0) {
					// Build JSON for data attribute (HTML encode quotes)
					const variationsJson = JSON.stringify(variations);
					const variationsAttr = variationsJson.replace(/"/g, '&quot;');

					// Extract unique sizes from variations
					const sizes = [];
					variations.forEach(variation => {
						// Handle API format: {attributes: {attribute_pa_size: "50"}, attribute_names: {attribute_pa_size: "50 ס"מ"}, variation_id: 123, is_in_stock: true}
						let sizeValue = null;
						let sizeName = null;
						if (variation.attributes) {
							if (typeof variation.attributes === 'object' && !Array.isArray(variation.attributes)) {
								// Format from PHP API: {attribute_pa_size: "50"}
								sizeValue = variation.attributes.attribute_pa_size || variation.attributes['attribute_pa_size'];
								// Get the display name from attribute_names if available
								if (variation.attribute_names) {
									sizeName = variation.attribute_names.attribute_pa_size || variation.attribute_names['attribute_pa_size'];
								}
							}
						}
						if (sizeValue && !sizes.find(s => s.value === sizeValue)) {
							sizes.push({
								value: sizeValue,
								name: sizeName || sizeValue, // Use name if available, fallback to slug
								variationId: variation.variation_id || variation.id,
								inStock: variation.is_in_stock !== false
							});
						}
					});

					// Build size options HTML
					let sizeOptionsHtml = '';
					if (sizes.length > 0) {
						sizeOptionsHtml = `
							<label for="size" class="variation-label">מידה:</label>
							<div class="size-swiper-wrapper">
								<div class="swiper-button-prev size-nav-btn">
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 20 21" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.93375 10.6661L15.1261 1.47371L14.419 0.766602L4.51953 10.6661L14.419 20.5656L15.1261 19.8585L5.93375 10.6661Z" fill="currentColor"></path></svg>
								</div>
								<div class="size-swiper swiper-container">
									<div class="swiper-wrapper">
										${sizes.map(size => {
								const stockClass = size.inStock ? 'in-stock' : 'no-stock';
								return `
											<div class="swiper-slide ${stockClass} variable-item button-variable-item" data-attribute_name="attribute_pa_size">
												<label class="variable-item-contents">
													<input type="radio" name="size-variation-${product.id}" value="${size.value}" data-variation_id="${size.variationId}">
													<span class="btn-size btn-variation variable-item-span variable-item-span-button">${size.name}</span>
												</label>
											</div>
										`;
							}).join('')}
									</div>
								</div>
								<div class="swiper-button-next size-nav-btn">
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 20 21" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.0663 10.6661L4.87387 1.47371L5.58097 0.766602L15.4805 10.6661L5.58097 20.5656L4.87387 19.8585L14.0663 10.6661Z" fill="currentColor"></path></svg>
								</div>
							</div>
						`;
					}

					variationHtml = `
						<div class="variation-item-attribute-wrap">
							<div class="variations-selector variations" data-product_id="${product.id}" data-product_variations="${variationsAttr}">
								${sizeOptionsHtml}
							</div>
							<button type="button" disabled data-variation_id="0" class="btn btn-upsell-add-cart product_type_variable add_to_cart_button"
								data-quantity="1" data-product_id="${product.id}" title="${self.texts.addToCart}">
								${self.texts.addToCart}
							</button>
						</div>
					`;
				} else if (isVariable) {
					// Variable product without variation data - link to product page
					variationHtml = `
						<div class="variations-selector variations" data-product_variations="false">
							<a href="${product.permalink}" class="btn btn-upsell-add-cart product_type_variable">
								בחר אפשרויות
							</a>
						</div>
					`;
				} else {
					// Simple product
					variationHtml = `
						<div class="variations-selector variations" data-product_variations="false">
							<button type="button" class="btn btn-upsell-add-cart product_type_simple add_to_cart_button"
								data-product_id="${product.id}" title="${self.texts.addToCart}">
								${self.texts.addToCart}
							</button>
						</div>
					`;
				}

				const $slide = $(`
					<div class="swiper-slide slide">
						<div class="mini-upsell-item">
							<div class="upsell-product-img">
								<a href="${product.permalink}">
									${product.featured_media?.includes('m3u8')
						? `<video class="mini-cart-video img-responsive" preload="metadata" data-video-url="${product.featured_media}"></video>`
						: `<img src="${product.featured_media ||
						self.placeholderImg
						}" alt="${product.name
						}" width="300" />`
					}
								</a>
							</div>
							<div class="upsell-product-detail d-flex flex-column">
								<p class="product-name">
									<a href="${product.permalink}">${product.name}</a>
								</p>
								<div class="product-price-wrap">
									<div class="prices">${product.price_html}</div>
								</div>
								${variationHtml}
							</div>
						</div>
					</div>
				`);
				// Aprimo MP4: the template above only treats m3u8 links as video.
				if (isAprimo(product.featured_media) && !$slide.find('video').length) {
					$slide.find('.upsell-product-img a').empty().append(
						$('<video class="mini-cart-video img-responsive" preload="metadata"></video>')
							.attr('data-video-url', product.featured_media)
							.attr('data-video-type', aprimoType(product.featured_media))
					);
				}

				$wrapper.append($slide);
			});

			return $sliderWrap;
		}

		/**
		 * Render minicart sale notification
		 */
		renderMinicartSaleNotification(cartData) {
			if (cartData.sale_notification) {
				this.minicartSaleNotification.html(
					'<div class="mini-cart-sale-notification-inner">' +
					cartData.sale_notification +
					'</div>'
				);
			}
		}

		/**
		 * Fetch WooCommerce cart data and render mini cart UI.
		 * @returns {jqXHR} jQuery AJAX promise for chaining
		 */
		fetchCart() {
			const self = this;

			// Fetch cart data from Store API
			return $.getJSON(self.apiBase + 'wc/store/v1/cart', function (data) {
				const symbol = data.totals.currency_symbol;

				// Update counter on cart icon
				if (data.items_count > 0) {
					self.$cartBtn.find('.counter').text(data.items_count);
				} else {
					self.$cartBtn.find('.counter').text('');
				}

				// Render free shipping message
				self.addFreeShippingNotice(data);

				// Render minicart sale notification
				self.renderMinicartSaleNotification(data);

				// If cart has items
				if (data.items_count > 0) {
					const $itemsWrap = $('<div>', {
						class: 'mini-cart-items mini-cart-items-list',
					});

					// Loop and render cart items
					$.each(data.items, function (i, item) {
						const $item = $(`
							<div class="mini-cart-item ${item.engraving_data ? 'has-engraving' : ''}">
								<div class="product-image">
									<a href="${item.permalink}">
										${item.featured_media?.includes(
							'm3u8'
						)
								? `<video class="mini-cart-video img-responsive" preload="metadata" data-video-url="${item.featured_media}"></video>`
								: `<img src="${item.featured_media ||
								self.placeholderImg
								}" alt="${item.name
								}" width="300" />`
							}
									</a>
								</div>
								<div class="product-detail">
									<div class="d-flex">
										<div class="product-name"><a href="${item.permalink}">${item.name}</a></div>
										<div class="product-variations">
											${item.variation
								.map(
									(item) =>
										`<div class="variation-item variation-text">${item.attribute}: ${item.value}</div>`
								)
								.join('')}
										</div>
										<div class="mini-cart-info">
											<div class="product-price">
												${item.has_awdr_discount
								? item.awdr_price_html
								: (item.is_on_sale
									? `<del class="regular-price">${symbol}${item.line_regular_total.toFixed(2)}</del><ins class="sale-price">${self.formatPrice(item.totals.line_total, symbol)}</ins>`
									: `<ins class="sale-price">${self.formatPrice(item.totals.line_total, symbol)}</ins>`)}
											</div>
											${item.engraving_data?.front_engraving_price ?? ''}
											${item.engraving_data?.back_engraving_price ?? ''}
										</div>
										${item.engraving_data?.total_price ?? ''}
									</div>
									<div class="d-flex align-items-end mini-cart-bottom">
										${!item.engraving_data ? `
											<div class="cart-quantity cart-quantity-controls">
												<a class="qty-btn qty-plus" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="currentColor" role="img" aria-hidden="true"><path class="plus" d="M5.5 6.49976V11.9998H6.5V6.49976L12 6.49976V5.49976L6.5 5.49976V-0.000244141H5.5V5.49976L0 5.49975V6.49975L5.5 6.49976Z"/></svg></a>
												<input type="text" min="1" class="qty-input actual-quantity quantityHidden cart_qty" value="${item.quantity
								}" data-key="${item.key}">
												<a class="qty-btn qty-minus" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="currentColor" role="img" aria-hidden="true"><path class="minus" d="M0 5.5h12v1H0z" fill="#211710"/></svg></a>
											</div>
										` : ''}
										<div class="qty_remove_wrap">
											<a href="#" class="cart-remove underline" data-key="${item.key}" data-product_id="${item.id}" data-parent_id="${item.parent_id || item.id}">${self.texts.removeItemText
							}</a>
										</div>
									</div>
									${item.trigger ? `<div class="trigger-link">${item.trigger}</div>` : ''}
								</div>
								${item.engraving_data?.edit_button ?? ''}
							</div>
						`);
						// Aprimo MP4: the template above only treats m3u8 links as video.
						if (isAprimo(item.featured_media) && !$item.find('video').length) {
							$item.find('.product-image a').empty().append(
								$('<video class="mini-cart-video img-responsive" preload="metadata"></video>')
									.attr('data-video-url', item.featured_media)
									.attr('data-video-type', aprimoType(item.featured_media))
							);
						}

						$itemsWrap.append($item);
					});

					// Append items to cart box
					self.$cartBox
						.find('.mini-cart-items-list')
						.replaceWith($itemsWrap);

					// Render and append cross-sells
					// Check if upsell should be hidden:
					// 1. If sessionStorage flag is NOT set → browser was closed → show upsell
					// 2. If sessionStorage IS set AND localStorage timestamp within 24 hours → hide
					// 3. If localStorage timestamp older than 24 hours → show upsell (reset)
					const sessionClosed = sessionStorage.getItem('minicart_upsell_closed') === 'true';
					const closedAt = localStorage.getItem('minicart_upsell_closed_at');
					const twentyFourHours = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
					const isWithin24Hours = closedAt && (Date.now() - parseInt(closedAt, 10)) < twentyFourHours;

					// Only hide if: session flag is set AND within 24 hours
					const upsellClosed = sessionClosed && isWithin24Hours;

					// If 24 hours passed, clear the storage to reset
					if (closedAt && !isWithin24Hours) {
						sessionStorage.removeItem('minicart_upsell_closed');
						localStorage.removeItem('minicart_upsell_closed_at');
					}
					// Cross-sells are already filtered server-side based on cart contents
					const crossSells = data.cross_sells || [];
					if (crossSells.length > 0 && !upsellClosed) {
						const $crossSell = self.renderCrossSellProducts(
							crossSells
						);
						self.$cartFooter
							.find('.mini-upsell-wrappper')
							.replaceWith($crossSell);

						if (self.swiperInstance) {
							self.swiperInstance.destroy(true, true);
						}

						self.swiperInstance = new Swiper('.mini-upsell-wrap', {
							slidesPerView: 1,
							spaceBetween: 10,
							direction: 'horizontal',
							rtl: true,
							autoHeight: true,
							navigation: true,
							observer: true,
							observeParents: true,
							pagination: {
								el: '.swiper-pagination',
								clickable: true,
								dynamicBullets: false,
							},
						});

						// Initialize nested size swipers
						self.$wrapper.find('.size-swiper').each(function () {
							const $container = $(this);
							const $wrapper = $container.closest('.size-swiper-wrapper');
							const slideCount = $container.find('.swiper-slide').length;
							const slidesToShow = 3;

							new Swiper(this, {
								slidesPerView: Math.min(slideCount, slidesToShow),
								spaceBetween: 4,
								nested: true,
								slidesPerGroup: 1,
								allowTouchMove: slideCount > slidesToShow,
								navigation: {
									nextEl: $wrapper.find('.swiper-button-next')[0],
									prevEl: $wrapper.find('.swiper-button-prev')[0],
								},
							});
						});
					} else {
						self.$cartFooter.find('.mini-upsell-wrappper').html('');
					}

					// Append footer with totals and checkout link
					const checkoutUrl =
						typeof mpParams.checkout_url !== 'undefined'
							? mpParams.checkout_url
							: '/checkout';
					const cartUrl =
						typeof mpParams.cart_url !== 'undefined'
							? mpParams.cart_url
							: '/cart';
					const $footer = $(`
						<div class="mini-cart-footer-content">
							<div class="cart-footer mt-auto">
								<table class="cart-sub-total">
									<tfoot>
										<tr>
											<td>${self.formatPrice(data.totals.total_items, symbol)}</td>
											<td>${self.texts.subtotalText}</td>
										</tr>
									</tfoot>
								</table>
								<div class="cart-footer-action">
									<a href="${checkoutUrl}" class="btn btn-primary">${self.texts.proceedToCheckoutText
						}</a>
									<a href="${cartUrl}" class="mini-cart-cart-btn">${self.texts.cartText}</a>
								</div>
							</div>
						</div>
					`);
					self.$wrapper
						.find('.mini-cart-footer-content')
						.replaceWith($footer);
					self.initVideoControls();
				} else {
					// Show empty cart state
					self.$wrapper
						.find('.mini-cart-footer-content')
						.replaceWith(
							'<div class="mini-cart-footer-content"></div>'
						);
					self.$cartBox.find('.mini-upsell-wrappper').html('');
					self.$cartBox.find('.mini-cart-items-list').html(
						`
						<div class="empty-cart-info text-center" dir="rtl">
							<div class="ico-cart"><i class="icon-shopping-bag"></i></div>
							<div class="cart-empty-message">${self.texts.emptyCartMessage}</div>
							<div class="cart-charm-messgae"> ` +
						__("זה הרגע להוסיף לה קצת ניצוץ 😊", 'matat_pandora') +
						`</div>
							<a href="/product-category/צארמס/" class="btn btn-primary">${self.texts.startShoppingText}</a>
						</div>
					`
					);
				}
			}).fail(function (xhr) {
				console.error('Cart fetch failed:', xhr);
			});
		}

		/**
		 * Show free shipping message and progress bar based on subtotal.
		 * @param {Object} cartData
		 */
		addFreeShippingNotice(cartData) {
			const self = this;
			let percentage = 0;

			$.getJSON(
				self.apiBase + 'matat-pandora/v1/free-shipping-notice',
				function (data) {
					if (
						!data.enabled ||
						!data.min_amount ||
						!cartData?.totals?.total_items
					)
						return;

					const minAmount = parseFloat(data.min_amount);
					const subtotal = cartData.totals.total_items / 100;
					const currencySymbol =
						cartData.totals.currency_symbol || '';
					const remaining = Math.max(0, minAmount - subtotal);
					percentage = Math.min(
						100,
						Math.round((subtotal / minAmount) * 100)
					);

					let messageHtml = '';

					if (subtotal > minAmount) {
						messageHtml = `<span class="remain-order-notice">${self.texts.freeShippingCongrats}</span>`;
					} else if (remaining > 0) {
						const formattedRemaining = `${currencySymbol}${remaining.toFixed(
							2
						)}`;
						const highlighted = `<span class="highlight">${formattedRemaining}</span>`;
						messageHtml = `<span class="remain-order-notice">${self.texts.freeShippingMissing.replace(
							'{amount}',
							highlighted
						)}</span>`;
					} else {
						messageHtml = `<span class="remain-order-notice">${self.texts.freeShippingExact}</span>`;
					}

					const $notice = $(`
					<div class="free-shipping-notice">
						<strong class="mini-cart-subheading">${messageHtml}</strong>
						<div class="progress">
							<div class="progress-bar" role="progressbar"
								style="width: ${percentage}%" aria-valuenow="${percentage}" aria-valuemin="0" aria-valuemax="100">
							</div>
						</div>
					</div>
				`);
					if (subtotal > 0) {
						self.$cartHeader
							.find('.free-shipping-notice')
							.replaceWith($notice);
					} else {
						self.$cartHeader
							.find('.free-shipping-notice')
							.replaceWith(
								'<div class="free-shipping-notice"></div>'
							);
					}

					if (percentage >= 100) {
						// check if giftBarProgress is eligible
						if (giftBarProgress.length > 0) {
							giftBarProgress.forEach((item) => {
								if (subtotal >= item.minimum_amount) {
									self.$cartHeader
										.find('.free-shipping-notice')
										.replaceWith(
											'<div class="free-shipping-notice"></div>'
										);
									self.addGiftBarProgress(cartData);
									return;
								}
							});
						}
					}
				}
			).fail(function (xhr) {
				console.error('Free shipping fetch failed:', xhr);
			});
		}

		/**
		 * Show gift bar progress bar
		/**
		 * Show gift bar progress bar
		 * @param {Object} cartData
		 */
		addGiftBarProgress(cartData) {
			const self = this,
				$target = self.$cartHeader.find('.free-shipping-notice');

			if (giftBarProgress.length > 0) {
				giftBarProgress.forEach((item) => {
					const subtotal = cartData.totals.total_items / 100;

					if (subtotal >= item.minimum_amount) {
						const percentage = Math.min(
							100,
							Math.round((subtotal / item.target_amount) * 100)
						);
						let remainingText = item.remaining_target_text;
						let remainingAmount = Math.max(
							0,
							item.target_amount - subtotal
						);
						//replace {{remaining_amt}} with the remaining amount
						remainingText = remainingText.replace(
							'{{remaining_amt}}',
							remainingAmount.toFixed(2)
						);
						if (percentage >= 100) {
							remainingText = item.target_reached_text;
							remainingText = remainingText.replace(
								'{{remaining_amt}}',
								remainingAmount.toFixed(2)
							);
						}

						const $giftBar = $(`
							<div class="free-shipping-notice">
								<strong class="mini-cart-subheading">${remainingText}</strong>
								<div class="progress">
									<div class="progress-bar" role="progressbar"
										style="width: ${percentage}%" aria-valuenow="${percentage}" aria-valuemin="0" aria-valuemax="100">
									</div>
								</div>
							</div>
						`);
						$target.append($giftBar);
					}
				});
			}
		}

		/**
		 * Update cart item quantity via WooCommerce Store API.
		 * @param {string} key
		 * @param {number} quantity
		 */
		updateCartItem(e) {
			const self = this,
				$target = $(e.currentTarget),
				key = $target.data('key'),
				quantityRaw = $target.val();

			let quantity = parseInt(quantityRaw, 10);
			if (isNaN(quantity) || quantity < 1) {
				quantity = 1;
				$target.val(quantity); // normalize UI
			}

			// show loader during AJAX update
			this.$wrapper
				.find('.pandora-cart-widget-wrapper')
				.addClass('show-loader');
			$.ajax({
				url: self.apiBase + 'wc/store/v1/cart/update-item',
				type: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Nonce: self.nonce,
				},
				data: JSON.stringify({ key, quantity }),
				success: function () {
					// Wait for fetchCart to complete before removing loader
					self.fetchCart()
						.always(function () {
							self.$wrapper
								.find('.pandora-cart-widget-wrapper')
								.removeClass('show-loader');
						});
				},
				error: function (xhr) {
					console.error('Update failed:', xhr.responseJSON || xhr);
					self.$wrapper
						.find('.pandora-cart-widget-wrapper')
						.removeClass('show-loader');
				},
			});
		}

		/**
		 * Remove item from cart using WooCommerce Store API.
		 * @param {string} key
		 */
		removeCartItem(e) {
			e.preventDefault();
			const self = this,
				$target = $(e.currentTarget),
				key = $target.data('key');

			// Show loader during remove operation
			this.$wrapper
				.find('.pandora-cart-widget-wrapper')
				.addClass('show-loader');

			$.ajax({
				url: self.apiBase + 'wc/store/v1/cart/remove-item',
				type: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Nonce: self.nonce,
				},
				data: JSON.stringify({ key }),
				success: function () {
					// GTM: fetch the buffered removedFromCart event.
					$(document.body).trigger('pandora_removed_from_cart');
					// Server will restore the product to upsell list on fetchCart
					// Wait for fetchCart to complete before removing loader
					self.fetchCart()
						.always(function () {
							self.$wrapper
								.find('.pandora-cart-widget-wrapper')
								.removeClass('show-loader');
						});
				},
				error: function (xhr) {
					console.error('Remove failed:', xhr.responseJSON || xhr);
					self.$wrapper
						.find('.pandora-cart-widget-wrapper')
						.removeClass('show-loader');
				},
			});
		}

		/**
		 * Close Cross Sell Product
		 */
		closeCrossSell(e) {
			e.preventDefault();
			const $button = $(e.currentTarget);
			const $wrapper = $button.closest('.mini-upsell-wrappper');
			if ($wrapper.length) {
				$wrapper.hide(500);
				// Store in sessionStorage (clears when browser closes)
				sessionStorage.setItem('minicart_upsell_closed', 'true');
				// Store timestamp in localStorage (for 24-hour expiration if browser stays open)
				localStorage.setItem('minicart_upsell_closed_at', Date.now().toString());
			}
		}

		/**
		 * Initialize video controls for product gallery.
		 */
		initVideoControls() {
			const $videos = this.$wrapper.find('video');

			$videos.each(function () {
				const $video = $(this);
				const videoEl = this; // DOM element
				const videoUrl = $video.data('video-url');

				if (!videoUrl) return;

				// Aprimo MP4 / HLS. Cloudflare continues to the hls.js code below.
				if (isAprimo(videoUrl)) {
					attachAprimoVideo(videoEl, videoUrl, {
						onReady: () => videoEl.play().catch(err => console.warn('Video play prevented:', err))
					});
					return;
				}

				if (Hls.isSupported()) {
					const hls = new Hls({
						enableWorker: true,
						lowLatencyMode: true,
						backBufferLength: 90,
					});

					hls.loadSource(videoUrl);
					hls.attachMedia(videoEl);

					hls.on(Hls.Events.MANIFEST_PARSED, function () {
						videoEl.muted = true;
						videoEl.loop = true;
						videoEl.playsInline = true;
						videoEl.play();
					});

					hls.on(Hls.Events.ERROR, function (event, data) {
						if (data.fatal) {
							switch (data.type) {
								case Hls.ErrorTypes.NETWORK_ERROR:
									console.error('Network error:', data);
									hls.startLoad();
									break;
								case Hls.ErrorTypes.MEDIA_ERROR:
									console.error('Media error:', data);
									hls.recoverMediaError();
									break;
								default:
									console.error('Fatal error:', data);
									hls.destroy();
									break;
							}
						}
					});
				} else if (
					videoEl.canPlayType('application/vnd.apple.mpegurl')
				) {
					// Native HLS support (Safari)
					videoEl.src = videoUrl;
					videoEl.addEventListener('loadedmetadata', function () {
						videoEl.muted = true;
						videoEl.loop = true;
						videoEl.playsInline = true;
						videoEl.play();
					});
				}
			});
		}
	}

	// Initialize the mini cart class on page load
	new Matat_Pandora_MiniCart();
});
